module.exports = __webpack_public_path__ + "assets/img/switch-on.d74d6f26.svg";